export enum ItemConfirmationType {
	Approve = "approve",
	TaskCompletion = "task-complete",
	ChangeRequest = "change-request",
	Delegation = "delegate",
	Rejection = "reject",
	Recall = "recall",
}
